/*=========================================================================================
  File Name: moduleRegionActions.js
  Description: Region Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
  AddRegion({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post("api/Region/AddRegion", item)
        .then((response) => {
          commit('ADD_ITEM', Object.assign(item, { ID: response.data.Data.ID }))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetAllRegions({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("api/Region/GetAllRegions")
        .then((response) => {
          commit('SET_Region', response.data.Data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  
  GetAllRegionsByCountryID({ commit }, CountryID) {
    return new Promise((resolve, reject) => {
      axios.get("api/Region/GetAllRegionByCountryID?CountryID="+CountryID)
        .then((response) => {
          commit('SET_Region', response.data.Data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  UpdateRegion({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post("api/Region/UpdateRegion", item)
        .then((response) => {
          commit('UPDATE_Region', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetRegion({ commit }, itemid) {
    return new Promise((resolve, reject) => {
      axios.post("api/Region/GetRegion", itemid)
        .then((response) => {
          commit('UPDATE_Region', response.data.Data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  DeleteRegion({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.delete("api/Region/DeleteRegion?ID="+item.ID)
        .then((response) => {
          commit('REMOVE_ITEM', item.ID)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
}
